

document.addEventListener('DOMContentLoaded', () => {
    var openMenuButton = document.querySelector('.header-menu-open');
    var closeMenuButton = document.querySelector('.header-menu-close');

    if (openMenuButton) {
        openMenuButton.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.add('header-menu-visible');
        });
    }
    if (closeMenuButton) {
        closeMenuButton.addEventListener('click', () => {
            document.body.classList.remove('header-menu-visible');
        });
    }

    //Toggle Language Switcher
    var languageSwitcherToggleButton = document.querySelector('.language-switcher > a.language-active');
    if (languageSwitcherToggleButton) {
        languageSwitcherToggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            languageSwitcherToggleButton.parentNode.classList.toggle('active');
        });
    }







});





// WEBPACK FOOTER //
// ./assets/src/js/modules/menu.js